module.exports = __webpack_public_path__ + "static/Titans-of-Resilience-132f2d3e9631455143e3bd0da8ca6738.jpg";